import { useHistory } from "react-router-dom/cjs/react-router-dom.min"
import { useDispatch } from "react-redux"

import { formatRelativeDate } from "../../../../../services/helper"
import { modifyNotification } from "../../../../../redux/actions/notification"
import { toast } from "../../../../CommonComponents/ToastComponent/toast"
import { useState } from "react"
import { Modal, Button, ButtonToolbar, Placeholder } from 'rsuite';
const PartnerSubmission = ({ key, notification, setCheckedKeys }) => {
    const history = useHistory()
    const dispatch = useDispatch()

    const [checked, setChecked] = useState(false)
    const [open, setOpen] = useState(false);
    const [supplierData, setSupplierData] = useState({});

    const handleClose = async (value, suppliername=null, matchedSupplierId=null, id=null) => {
        setOpen(false);
        let notificationIds = []
        notificationIds.push(notification?.notificationid)
        await dispatch(modifyNotification(notificationIds, "markAsRead")).then((res) => res).catch((err) => {
            if (err) {
                toast.show({
                    title: 'Danger',
                    description: 'Unable To Modify From Unread To Read'
                })
            }
        })
        if(value){
            await dispatch(modifyNotification([id ?? supplierData?.id], "markAsRead", "partnerSubmissions")).then((res) => res).catch((err) => {
                if (err) {
                    toast.show({
                        title: 'Danger',
                        description: 'Unable To Modify Read'
                    })
                }
            })
        }


        const status = matchedSupplierId===null || supplierData?.matchedSupplierId===null ? "unmatched" : "matched";

        history.push({
            pathname: `/lists/partner-submissions`,
            state: { supplierName: suppliername ?? supplierData?.suppliername, status },
        });
        setSupplierData({});
    };

    const onDetailHandler = async (data) => {
        const {suppliername, matchedSupplierId, id, isRead} = data;
        if(isRead){
            handleClose(false, suppliername, matchedSupplierId, id); 
        }else{
           setSupplierData({suppliername, matchedSupplierId, id});
           setOpen(true);
        }
    }


    const checkHandler = (checked) => {
        setChecked(checked)
        checked ? setCheckedKeys(prevState => [...prevState, notification?.id]) :  setCheckedKeys(prevState => prevState?.filter(id => id !== notification?.id))
    }
    
    let time = formatRelativeDate(notification?.createdAt)
    return (
        <div key={key} className={`container-fluid py-2 py-3 d-flex column-gap-3 mb-3 rounded ${!notification?.isRead && 'border'}`} style={{ backgroundColor: notification?.isRead ? "aliceblue" : "#fff" }}>
            <div className="d-flex column-gap-4 col-1 align-items-center">
                <button className="rounded-circle border p-2" style={{ width: '50px', height: '50px' }}><i class="bi bi-person-square fs-2"></i></button>
                <input type="checkbox" style={{ width: 15, height: 15 }} onChange={(e) => { checkHandler(e?.target?.checked) }}  checked={checked}/>
            </div>
            <div className="d-flex col-11">
                <div className="col-2  align-self-center" title="Supplier Name">
                    <p className="m-0 fs-4  text-black">{notification?.suppliername || 'No Data'}</p>
                </div>
                <div className="col-1  align-self-center" title="Match Status" >
                    <p className="m-0 fs-4  text-black">{notification?.matchStatus || 'No Data'}</p>
                </div>
                <div className="col-2  align-self-center" title="Partner Name">
                    <p className="m-0 fs-4  text-black">{notification?.partnerName || 'No Data'}</p>
                </div>
                <div className="col-1  align-self-center" title="Created At">
                    <p className="m-0 fs-4  text-black">{time || 'No Data'}</p>
                </div>
                <div className="col-1  align-self-center" title="Address 1">
                    <p className="m-0 fs-4  text-black">{notification?.address1 || 'No Data'}</p>
                </div>
                <div className="col-1  align-self-center" title="City">
                    <p className="m-0 fs-4  text-black">{notification?.city || 'No Data'}</p>
                </div>
                <div className="col-1  align-self-center" title="State">
                    <p className="m-0 fs-4  text-black">{notification?.state || 'No Data'}</p>
                </div>
                <div className="col-1  align-self-center" title="Zip">
                    <p className="m-0 fs-4  text-black">{notification?.zip || 'No Data'}</p>
                </div>
                <div className="col-2 fs-4 align-self-center text-center">
                    <button className="report_small_button_success" onClick={() => { onDetailHandler(notification) }}>Details</button>
                </div>
            </div>
        
        {open ?
            <Modal show={open} onHide={()=>setOpen(false)}>
                <Modal.Header>
                <Modal.Title>Are you want to read this supplier?</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                </Modal.Body>
                <Modal.Footer>
                <Button onClick={()=>handleClose(true)} appearance="primary" className="report_small_button_success">
                    Yes
                </Button>
                <Button onClick={()=>handleClose(false)} appearance="subtle" className="report_small_button_grey">
                    No
                </Button>
                </Modal.Footer>
            </Modal>
         : null }
        </div>
    )
}

export default PartnerSubmission